module.exports = __webpack_public_path__ + "assets/recover-password.774d1dce.svg";